import i18next from 'i18next';
import Moment from 'moment';
import localeEnGb from 'moment/locale/en-gb.js';
import localeFr from 'moment/locale/fr.js';

export default {
  /**
   * Gets a language from a locale with a region.
   * Examples:
   *  - en-GB => en
   *  - fr-CA => fr
   *
   * @param {String} locale   The locale
   * @returns {String}        The language code
   */
  getLanguageFromLocale(locale) {
    return locale.split('-')[0];
  },

  /**
   * Set moment locale globally
   *
   * @param {String} locale Locale string (en-gb, fr, de, etc.)
   */
  setMomentLocale(locale) {
    Moment.locale(this.normalizeLocale(locale));
  },

  /**
   * Normalize the locale string.
   * e.g.
   *   en_GB => en-gb
   *   fr_FR => fr-fr
   *
   * @param  {String} locale Locale string.
   * @return {String} Normalized locale string.
   */
  normalizeLocale(locale) {
    return locale ? locale.toLowerCase().replace('_', '-') : locale;
  },

  /**
  * Gets the webbrowser locale.
  *
  * @returns {String} The locale, in a format like "en-GB", "fr-CA"...
  */
  getBrowserLocale() {
    return navigator.userLanguage || navigator.language
      || navigator.browserLanguage || navigator.systemLanguage;
  },

  async setupI18Next(translations, locale, fallbackLocale) {
    return i18next.init({
      debug: process.env.NODE_ENV === 'development',
      lng: locale,
      nsSeparator: false,
      keySeparator: false,
      fallbackLng: fallbackLocale,
      interpolation: {
        prefix: '%{',
        suffix: '}',
      },
      resources: translations,
    });
  },
};



// WEBPACK FOOTER //
// ./src/locales/helper.js